export const routes = {
  PROFILE: '/profile',
};
